import { render, staticRenderFns } from "./tabVessels.vue?vue&type=template&id=cbcd284c&scoped=true"
import script from "./tabVessels.vue?vue&type=script&lang=js"
export * from "./tabVessels.vue?vue&type=script&lang=js"
import style0 from "./tabVessels.vue?vue&type=style&index=0&id=cbcd284c&prod&lang=scss"
import style1 from "./tabVessels.vue?vue&type=style&index=1&id=cbcd284c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbcd284c",
  null
  
)

export default component.exports